import { authParamsRepository } from '@/infra/repository/AuthParamsRepository';
import { ssoParamsRepository } from '@/infra/repository/SSOParamsRepository';

export const readyRepositories = async () => {
    await authParamsRepository.ready();
    await ssoParamsRepository.ready();
};
